const logEvent = () => {
  return true;
};

const logPurchase = () => {
  return true;
};

const logPurchaseGA = () => {
  return true;
};

const logBannerCLick = () => {
  return true;
};

const logEgiftProduct = () => {
  return true;
};

const logCurrentScreen = () => {
  return true;
};

const logBuyNowClicked = () => {
  return true;
};

const logProceedToCheckout = () => {
  return true;
};

const logProceedToPaymentClicked = () => {
  return true;
};

const logCancelOrderButtonClicked = () => {
  return true;
};

const logProceedToCancelClicked = () => {
  return true;
};

const logCancelledOrder = () => {
  return true;
};

export {
  logEvent,
  logPurchaseGA,
  logPurchase,
  logEgiftProduct,
  logCurrentScreen,
  logBannerCLick,
  logBuyNowClicked,
  logProceedToCheckout,
  logProceedToPaymentClicked,
  logCancelOrderButtonClicked,
  logProceedToCancelClicked,
  logCancelledOrder,
};
